export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=401bdda7a2e46b7f7ab170c4b0cd6c7cfbce187d20&name=revalidateCommunity!'